export default () => {
    return {
        mounted() {
            ScrollTrigger.matchMedia({
                '(max-width:1023px)': () => {
                    gsap.set(this.$refs.col01, { yPercent: 0 });
                    gsap.set(this.$refs.col02, { yPercent: 0 });
                },
                '(min-width:768px)': () => {
                    this.pin();
                },
                '(min-width:1024px)': () => {
                    this.parallax();
                }
            });

            // Re-measure after the page has fully settled. ScrollTrigger's
            // automatic refresh on `load` can fire during transient layout
            // shifts and lock in incorrect start positions.
            const refresh = () => setTimeout(() => ScrollTrigger.refresh(), 600);
            if (document.readyState === 'complete') {
                refresh();
            } else {
                window.addEventListener('load', refresh, { once: true });
            }
        },

        pin() {
            ScrollTrigger.create({
                trigger: this.$refs.container,
                start: 'top 128px',
                end: 'bottom bottom',
                pin: this.$refs.pinElement,
                anticipatePin: 1
            });
        },

        parallax() {
            const move = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$refs.container,
                    scrub: 0.8,
                    onEnter: () => {
                        ScrollTrigger.refresh(true);
                    }
                }
            });

            move.fromTo(this.$refs.col01, { yPercent: 30 }, { yPercent: -30, ease: 'none' }).fromTo(
                this.$refs.col02,
                { yPercent: 10 },
                { yPercent: -15, ease: 'none' },
                '<0'
            );
        }
    };
};
